import React from 'react'

const Rat_in_Maze = () => {
    return (
        <div className='container'>
            <h1>Rat in a Maze</h1>
            <div className='containers'>
            A Maze is given as N*N binary matrix of blocks where source block is the upper
             left most block i.e., maze[0][0] and destination block is lower rightmost 
             block i.e., maze[N-1][N-1]. A rat starts from source and has to reach the
              destination. The rat can move only in two directions: forward and down. <br />
In the maze matrix, 0 means the block is a dead end and 1 means the block can be
 used in the path from source to destination. Note that this is a simple version of the 
 typical Maze problem. For example, a more complex version can be that the rat can move 
 in 4 directions and a more complex version can be with a limited number of moves. <br />
            </div>
            <div className='containers'>
                
<code className='library'>#include</code>  &lt;stdio.h&gt;<br />
<br />
<code className='comment'>// Maze size</code><br />
<code className='library'>#define</code> N 4<br />
<br /><br />
<code className='library'>bool</code> solveMazeUtil(int maze[N][N], int x, int y, int sol[N][N]);<br />
<br />
<code className='library'>/* A utility function to print solution matrix sol[N][N] */</code><br />
<code className='library'>void</code> printSolution(int sol[N][N])<br />
&#123;<br />
<code className='keywords'>for</code> (int i = 0; i &lt; N; i++) &#123;<br />
<code className='keywords'>	for </code>(int j = 0; j &lt; N; j++)<br />
<code className='library'>		printf</code>(" %d ", sol[i][j]);<br />
<code className='library'>	printf</code>("\n");<br />
	&#125;<br />
&#125;<br />
<br />
<code className='comment'>/* A utility function to check if x, y is valid index for N*N maze */</code> <br />
<code className='keywords'>bool </code>isSafe(int maze[N][N], int x, int y)<br />
&#123;<br />
<code className='library'>	// if (x, y outside maze) return false</code><br />
<code className='library'>if</code> (x &gt;= 0 && x &lt; N && y &gt;= 0 && y &lt; N && maze[x][y] == 1)<br />
<code className='library'>	return</code> true;<br />
<br />
<code className='library'>return</code> false;<br />
&#125;<br />
<br />
<code className='comment'>/* This function solves the Maze problem using Backtracking. It mainly
uses solveMazeUtil() to solve the problem. It returns false if no
path is possible, otherwise return true and prints the path in the
form of 1s. Please note that there may be more than one solutions,
this function prints one of the feasible solutions.*/</code>
<code className='keywords'>bool</code> solveMaze(int maze[N][N])<br />
&#123;<br />
<code className='keywords'>	int</code> sol[N][N] = &#123; &#123; 0, 0, 0, 0 &#125;<br />
					&#123; 0, 0, 0, 0 &#125;,<br />
					&#123; 0, 0, 0, 0 &#125;,<br />
					&#123; 0, 0, 0, 0 &#125; &#125;;<br />
                    <br />
                    <code className='library'>	if </code> (solveMazeUtil(maze, 0, 0, sol) == false) &#123;<br />
                    <code className='library'>	printf</code>("Solution doesn't exist");<br />
                    <code className='library'>	return</code> false;<br />
	&#125;<br />
    <br />
	printSolution(sol);<br />
    <code className='library'>	return</code> true;<br />
&#125;<br />
<br />
<code className='keywords'>/* A recursive utility function to solve Maze problem */</code><br />
<code className='keywords'>bool </code>solveMazeUtil(int maze[N][N], int x, int y, int sol[N][N])<br />
&#123;<br />
<code className='comment'>	// if (x, y is goal) return true</code><br />
<code className='keywords'>	if</code> (x == N - 1 && y == N - 1) &#123;<br />
		sol[x][y] = 1;<br />
        <code className='library'>	return</code> true;<br />
	&#125;<br />
    <br />
	<code className='comment'>// Check if maze[x][y] is valid</code><br />
    <code className='keywords'>	if</code> (isSafe(maze, x, y) == true) &#123;<br />
	<code className='comment'>	// mark x, y as part of solution path</code><br />
               	sol[x][y] = 1;<br />
                   <br />
	<code className='comment'>	/* Move forward in x direction */</code><br />
	<code className='keywords'>	if</code> (solveMazeUtil(maze, x + 1, y, sol) == true)<br />
	<code className='library'>		return</code> true;<br />
    <br />
	<code className='library'>	/* If moving in x direction doesn't give solution then<br />
		Move down in y direction */</code><br />
        <code className='library'>	if </code>(solveMazeUtil(maze, x, y + 1, sol) == true)<br />
        <code className='library'>		return</code> true;<br />
        <br />
        <code className='comment'>	/* If none of the above movements work then BACKTRACK:<br />
			unmark x, y as part of solution path */</code><br />
		sol[x][y] = 0;<br />
        <code className='library'>	return</code> false;<br />
	&#125;<br />
    <br />
    <code className='library'>	return</code> false;<br />
&#125;<br />
<br />
<code className='keywords'>int</code> main()<br />
&#123;<br />
<code className='keywords'>int</code> maze[N][N] = &#123; &#123; 1, 0, 0, 0 &#125;,<br />
					&#123; 1, 1, 0, 1 &#125;,<br />
					&#123; 0, 1, 0, 0 &#125;,<br />
					&#123; 1, 1, 1, 1 &#125; &#125;;<br />
                    <br />
	solveMaze(maze);<br />
	<code className='library'>return</code> 0;<br />
&#125;<br />
<br />
            </div>
        </div>
    )
}

export default Rat_in_Maze
